import { observer } from "mobx-react-lite";
import { FC } from "react";

import { useViewModel } from "@/hooks/use-view-model";
import { useGlobalStore } from "@/stores";
import { Entity } from "@/types";

import { FormState } from "./FormState";
import { FormView } from "./FormView";

export type Props = {
  entity: Entity;
  readOnly?: boolean;
};

export const Form: FC<Props> = observer((props) => {
  const { intlService, permissionsStore } = useGlobalStore();
  const vm = useViewModel(
    () => new FormState(intlService, permissionsStore),
    props,
  );
  return <FormView state={vm} />;
});
